import {
	GET_CATEGORY_SELECTION_SUCCESS,
	SET_CATEGORY_SELECTION_SUCCESS,
	SUBMIT_SELECTION_SUCCESS,
	SUBMIT_INFO_SUCCESS,
} from 'client/constants';

/**
 * {
 * 		'1970': {
 * 			isSelectionSubmitted: false,
 * 			isInfoSubmitted: false,
 * 			selectedItems: ['id', 'id']
 * 		}
 * }
 */
const initialState = {};

export default function selectionReducer(state = initialState, { type, payload }) {
	switch (type) {
		case GET_CATEGORY_SELECTION_SUCCESS:
			return {
				...state,
				[payload.categoryId]: payload.selection,
			};

		case SET_CATEGORY_SELECTION_SUCCESS:
			return {
				...state,
				[payload.categoryId]: payload.selection,
			};

		case SUBMIT_SELECTION_SUCCESS:
			return {
				...state,
				[payload.categoryId]: {
					...state[payload.categoryId],
					isSelectionSubmitted: true,
				},
			};

		case SUBMIT_INFO_SUCCESS:
			return {
				...state,
				[payload.categoryId]: {
					...state[payload.categoryId],
					isInfoSubmitted: true,
				},
			};

		default:
			return state;
	}
}
